import { render, staticRenderFns } from "./bidding09.vue?vue&type=template&id=b28f6a58&scoped=true&"
import script from "./bidding09.vue?vue&type=script&lang=js&"
export * from "./bidding09.vue?vue&type=script&lang=js&"
import style0 from "./bidding09.vue?vue&type=style&index=0&id=b28f6a58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28f6a58",
  null
  
)

export default component.exports